import { createAction } from 'typesafe-actions';

export const resetHeaderState = createAction('RESET_HEADER_STATE')<undefined>();

export const setHeaderAction = createAction('SET_HEADER')<undefined>();
